import React from 'react'
import { Box, Container } from '@material-ui/core'
import RichText from '../RichText'
import AnimatedText from '../AnimatedText'
import { useStyles } from './HeroSectionGrey.styles'

const HeroSectionGrey = ({ t, heading, description }) => {
  const styles = useStyles()
  return (
    <Box className={styles.bannerContainer}>
      <Container maxWidth="lg">
        {heading && (
          <Box className={styles.bannerTextWrapper}>
            <AnimatedText animationType="wavy" variant="h2" content={heading} />
            {description && (
              <RichText
                variant="body1"
                document={JSON.parse(description.raw)}
                className={styles.bannerText}
              />
            )}
          </Box>
        )}
      </Container>
    </Box>
  )
}

export default HeroSectionGrey
